/* The help card's rows. The card and the row's own box are `AccountScreen.module.css`'s, so this
 * file declares only what a LINK adds on top of a row: the pointer, the ink step on hover and the
 * focus ring the anchor owes. */

.link {
  cursor: pointer;
}

/* Element selectors, because the row's own classes live in a DIFFERENT CSS module and a scoped
 * class name from there cannot be spelled here. The word and the arrow both step to primary. */
.link:hover b,
.link:hover svg {
  color: var(--text);
}

.link:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-minus-2px);
  border-radius: var(--radius-sm);
}
